import Vue from 'vue'
import VueRellax from 'vue-rellax'
import { redirectTimeout } from '../router/index.js'

Vue.use(VueRellax)

export default {
  data () {
    return {
      rellax: false,
      rellaxConfig: {
        speed: -10
      }
    }
  },

  methods: {
    initRellax () {
      this.$el.style.transform = 'translate3d(0, 0, 0)'
      if (!this.withMobileRellax && window.innerWidth < 1025) {
        this.destroyRellax()
        return
      }
      this.rellax = this.rellaxConfig
    },

    destroyRellax () {
      this.rellax = false
    }
  },

  mounted () {
    this.initRellax()

    // Фикс для iOS
    setTimeout(() => {
      window.scrollTo({
        top: 10,
        behavior: 'instant'
      })
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }, 
    redirectTimeout)
  }
}
